// Module
var code = "<template><require from=\"../loading/loading\"></require><button class=\"fab-button ${disabled? 'is-disabled':''} ${loading? 'is-loading':''}\" disabled.bind=\"disabled\"><i class=\"fab-button-icon material-icons\" if.bind=\"!loading\">${icon}</i><loading class=\"small color-white\" if.bind=\"loading\"></loading></button></template>";
// Exports
module.exports = code;